/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {saveUserApiKey} from '../api'

export const useMutationSaveUserApiKey = createReactQueryMutationHook('saveUserApiKey', saveUserApiKey)
